<template>
    <div>
        <div :class="{'form-group':formGroup,'text-danger':validClass,'row':vertical}">
            <label class="col-form-label" :class="{'text-danger':validClass,'col-lg-3':vertical, 'padding-top-zero':!vertical}" v-if="label">{{label}}</label>
            <div :class="{'col-lg-9':vertical}">
                <input
                    :type="type"
                    class="form-control"
                    :class="{'border-danger':validClass,'text-danger':validClass}"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    :value="inputValue"
                    :min="min"
                    @input="changeValue"
                    v-on:keyup.enter="enterEvent"
                    :readonly="readonly">
                <span class="form-text" :class="{'border-danger':validClass,'text-danger':validClass}" v-for="resultStr in validationResult" :key="resultStr">{{resultStr}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import validation from "@/config/mixin/validation";
    export default {
        name: "BasicInput",
        mixins:[validation],
        props: {
            type: {
                type:String,
                default() {
                    return 'text'
                }
            },
            formGroup: {
                type:Boolean,
                default() {
                    return true
                }
            },
            label: {
                type: String,
            },
            vertical: {
                type: Boolean,
                default:false
            },
            placeholder: {
                type: String,
                default() {
                    return ''
                }
            },
            disabled: {
                type:Boolean,
                default() {
                    return false
                }
            },
            rule: {
                type: String
            },
            value: {
            },
            additionalValidationResult: {
                type: Array,
                default() {
                    return []
                }
            },
            validGroup: {
                type: String,
                default() {
                    return ''
                }
            },
            min: {
                type: String
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                inputValue: '',
            }
        },
        computed: {
            validClass: function() {
                return this.validationResult.length > 0
            }
        },
        mounted() {
            this.inputValue = this.value
        },
        methods: {
            validator: function() {
                this.validationResult = this.getValidationResult(this.rule,this.inputValue)
                this.validationResult = [...this.validationResult,...this.additionalValidationResult]
                return this.validationResult
            },
            changeValue: function(e) {
                this.$emit('input',e.target.value)
            },
            enterEvent: function(e) {
                this.$emit('enterEvent',e)
            },
            resetValidation() {
              this.inputValue = null
              this.resetValidationResult()
            }
        },
        watch: {
            'value': function(val) {
                this.inputValue = this.value
                if(val) this.validator()
            }
        }
    }
</script>

<style scoped>
.padding-top-zero {
    padding-top:0px !important;
}
</style>
